<template>
  <SoDataIterator :items="pageItems">
    <template #default="{ item, index }">
      <div
        class="customer-operations-newsfeed mt-5 mb-10"
        data-testid="news-feed-item"
      >
        <NewsFeed :id="index" :news-feed="item" />
      </div>
    </template>
  </SoDataIterator>
  <SoPagination
    v-show="newsFeeds?.length > pageSize"
    :key="newsFeeds?.length"
    v-model="pageItems"
    :list="newsFeeds"
    :page-size="pageSize"
  >
  </SoPagination>
</template>

<script lang="ts">
  import { defineComponent, PropType } from "vue"
  import NewsFeed from "@/views/customer/search/components/newsFeed/NewsFeed.vue"
  import SoPagination from "@/components/SoPagination.vue"
  import SoDataIterator from "@/components/SoDataIterator.vue"
  import { INewsfeedItem } from "@/models/newsfeed/newsfeed.types"

  export default defineComponent({
    components: {
      SoDataIterator,
      SoPagination,
      NewsFeed,
    },
    props: {
      newsFeeds: {
        type: Array as PropType<INewsfeedItem[]>,
        default: () => [],
        required: true,
      },
    },
    data() {
      return {
        pageSize: 15,
        pageItems: [] as INewsfeedItem[],
      }
    },
  })
</script>
